export enum AuroraHeatingElementMode {
  OFF = 'off',
  LOCAL_AUTOMATION = 'local_automation',
  CLOUD_AUTOMATION = 'cloud_automation'
}

export default AuroraHeatingElementMode
